<div class="task-list">
    <button type="button" class="task-row" *ngFor="let task of tasks" (click)="openTask(task)" [disabled]="!task.navigateUrl && !task.clickFunc" [class.is-disabled]="!task.navigateUrl && !task.clickFunc" [title]="task.tooltip || ''">
        <span class="task-icon"><i [class]="task.iconClass"></i></span>
        <span class="task-copy"><strong>{{task.taskTitle}}</strong><small *ngIf="task.tooltip">{{task.tooltip}}</small></span>
        <i class="fa fa-chevron-right" *ngIf="task.navigateUrl || task.clickFunc"></i>
    </button>
</div>
